var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppleStoreIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    fill: "#382E2E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gamers wallet",
    clipPath: "url(#clip0_2997_11691)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 4833,
    transform: "translate(-266 -467)",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 32966",
    clipPath: "url(#clip1_2997_11691)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 758,
    transform: "translate(-266 -385)",
    fill: "#020733"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 13592"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 53",
    filter: "url(#filter0_f_2997_11691)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -94.5,
    cy: -194.5,
    r: 232.5,
    fill: "#3333FF",
    fillOpacity: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 32994"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 32993"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 32962"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 32961"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 32983"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 32977",
    clipPath: "url(#clip2_2997_11691)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 32981"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 32980"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 32979"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ion:logo-apple-appstore"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.5 1.9375C8.00793 1.9375 1.9375 8.00793 1.9375 15.5C1.9375 22.9921 8.00793 29.0625 15.5 29.0625C22.9921 29.0625 29.0625 22.9921 29.0625 15.5C29.0625 8.00793 22.9921 1.9375 15.5 1.9375ZM10.3535 21.4269C10.2703 21.5689 10.1512 21.6864 10.0081 21.7677C9.86504 21.849 9.7031 21.8912 9.53855 21.8901C9.37085 21.8916 9.20606 21.8463 9.06266 21.7593C8.95588 21.6975 8.86238 21.6151 8.78751 21.517C8.71265 21.4189 8.65789 21.307 8.62639 21.1877C8.59488 21.0683 8.58725 20.944 8.60394 20.8217C8.62062 20.6994 8.66128 20.5817 8.72359 20.4751L9.64935 18.936C9.69614 18.8566 9.76288 18.7908 9.84297 18.7451C9.92305 18.6994 10.0137 18.6755 10.1059 18.6757H10.2427C10.9142 18.6757 11.384 19.0795 11.5209 19.4707L10.3535 21.4269ZM18.1913 18.3996L12.1288 18.4062H8.09936C7.97258 18.4068 7.84702 18.3816 7.73028 18.3321C7.61355 18.2827 7.50808 18.21 7.42026 18.1186C7.33245 18.0271 7.26412 17.9188 7.21943 17.8002C7.17474 17.6815 7.15461 17.5551 7.16027 17.4284C7.17965 16.9198 7.62346 16.5347 8.12902 16.5347H11.0498L14.5125 10.6405L13.3912 8.73025C13.1387 8.29492 13.2507 7.72094 13.6836 7.44727C13.7903 7.37824 13.9099 7.33151 14.0352 7.30989C14.1604 7.28826 14.2887 7.29219 14.4124 7.32143C14.5361 7.35067 14.6526 7.40462 14.7549 7.48004C14.8572 7.55546 14.9432 7.65079 15.0078 7.76029L15.6072 8.78414H15.6138L16.2138 7.76029C16.2784 7.65135 16.3643 7.55654 16.4663 7.4815C16.5684 7.40646 16.6844 7.35273 16.8077 7.32352C16.9309 7.29431 17.0588 7.29021 17.1836 7.31147C17.3085 7.33273 17.4278 7.37891 17.5344 7.44727C17.9649 7.72094 18.0757 8.29492 17.8214 8.73207L16.7 10.6423L15.6102 12.5005L13.2434 16.5366V16.5432H16.7315C17.1687 16.5432 17.7166 16.7781 17.9382 17.156L17.9576 17.1953C18.1532 17.5277 18.264 17.756 18.264 18.0884C18.2608 18.1963 18.2367 18.3026 18.1931 18.4014L18.1913 18.3996ZM22.8988 18.4062H21.2574V18.4129L22.4574 20.4539C22.5865 20.6689 22.626 20.9259 22.5675 21.1697C22.5089 21.4135 22.357 21.6246 22.1444 21.7575C21.997 21.8474 21.8278 21.8949 21.6552 21.895C21.4911 21.8949 21.3298 21.8524 21.187 21.7715C21.0442 21.6907 20.9247 21.5743 20.8402 21.4336L19.0668 18.4147L17.9649 16.5378L16.5432 14.1074C16.3373 13.7604 16.2254 13.3657 16.2185 12.9622C16.2116 12.5588 16.3099 12.1605 16.5039 11.8066C16.7848 11.3108 16.9997 11.1806 16.9997 11.1806L20.1621 16.5293H22.8813C23.3899 16.5293 23.8264 16.9204 23.85 17.4224C23.8549 17.55 23.834 17.6773 23.7884 17.7966C23.7429 17.9159 23.6737 18.0248 23.585 18.1167C23.4964 18.2086 23.39 18.2816 23.2724 18.3313C23.1548 18.3811 23.0284 18.4066 22.9006 18.4062H22.8988Z",
    fill: "white"
  })))))))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2997_11691",
    x: -657,
    y: -757,
    width: 1125,
    height: 1125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 165,
    result: "effect1_foregroundBlur_2997_11691"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2997_11691"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 4833,
    fill: "white",
    transform: "translate(-266 -467)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2997_11691"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 758,
    fill: "white",
    transform: "translate(-266 -385)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2997_11691"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 418,
    height: 107,
    fill: "white",
    transform: "translate(-114 -66)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleStoreIcon);
export default __webpack_public_path__ + "static/media/apple-store-icon.c86c69a9aee4a2d122563dd32460758d.svg";
export { ForwardRef as ReactComponent };